import { Component, OnInit } from '@angular/core';
import { UserLogicService } from '../../logic/user.service'
import { Router } from '@angular/router';
import { PassDataService } from '../../services/pass-data.service';

@Component({
  selector: 'profile-pg',
  templateUrl: './profile.component.html',
})
export class ProfilePage implements OnInit {

  update: string = 'Update';
  firstName: string = "";
  lastName: string = "";
  email: string = "";
  password: string = "";
  _id: string = "";

  constructor(private userLogicService: UserLogicService, private router: Router, private passDataService: PassDataService
) { }

  ngOnInit(): void {

    let user: string = localStorage.getItem("user") as string;
    let userJson = JSON.parse(user);

    this.firstName = userJson.firstName;
    this.lastName = userJson.lastName;
    this.email = userJson.email;
    this._id = userJson._id;

  }

  onUpdateClick() {

    this.passDataService.setPopup({
      isPopup: true,
      message: '',
      isOk: false,
      isDelete: false,
      isLoading: true,
      loadingMessage: 'Updating Profile, please wait!',
    });

    this.userLogicService.userUpdateLogic({
      _id: this._id,
      firstName: this.firstName,
      lastName: this.lastName,
      email: this.email,
      password: this.password
    }).subscribe((s: any) => {
      this.passDataService.setActivatedTitle("SlokaTypes");
      this.router.navigate([`/page`])
      localStorage.setItem("user", JSON.stringify(s.data.updatedUser));
      localStorage.setItem("email", this.email);

      if(this.password != ""){
        localStorage.setItem("password", this.email);
      }

        this.passDataService.setPopup({
          isPopup: true,
          message: "Profile updated successfully!",
          isOk: true,
          isDelete: false,
          isLoading: false,
          loadingMessage: '',
        });

    }, (err: any) => {
      console.log("e ", err)
    })
  }

}
